import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/** SSR-safe: returns false during prerender/hydration, then the real preference. */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia(QUERY)
    const update = () => setReduced(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  return reduced
}